import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Badge, useLocalizeMessage } from 'libs.nucleus';
export const useDimensionsColumns = () => {
    const translate = useLocalizeMessage();
    return useMemo(() => [
        {
            header: translate('Internal name'),
            accessorKey: 'name',
            cell: ({ row }) => _jsx("div", { className: 'font-medium', children: row.original.name }),
        },
        {
            header: translate('Display name'),
            accessorKey: 'title',
            cell: ({ row }) => row.original.title || '-',
        },
        {
            header: translate('Type'),
            accessorKey: 'type',
            cell: ({ row }) => {
                const typeLabels = {
                    number: translate('Number'),
                    string: translate('Text'),
                    time: translate('Date Time'),
                };
                return typeLabels[row.original.type] || row.original.type || '-';
            },
        },
        {
            header: translate('Description'),
            accessorKey: 'description',
            cell: ({ row }) => row.original.description || '-',
        },
        {
            header: translate('Visibility'),
            accessorKey: 'isVisible',
            size: 100,
            cell: ({ row }) => (_jsx(Badge, { variant: row.original.isVisible !== false ? 'success' : 'common', label: row.original.isVisible !== false ? translate('Visible') : translate('Hidden') })),
        },
    ], [translate]);
};
